import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';
import { WalletProvider } from './_shared/wallet-app/WalletProvider';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <WalletProvider appName="Bridge — Bankcoin Capital" autoAuthenticate={false}>
        <App />
      </WalletProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
